"use client"

import { useState } from "react"
import { IconChevronDown } from "@tabler/icons-react"
import { motion } from "framer-motion"

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const faqs = [
    {
      question: "Не будут ли ответы звучать роботизированно?",
      answer:
        "InstaSell обучается на ваших реальных сообщениях, копируя ваш уникальный стиль, эмодзи и терминологию. 92% клиентов не замечают разницы между вашими ответами и автоматическими. Плюс вы всегда можете скорректировать стиль общения в настройках.",
    },
    {
      question: "Что если клиент задаст сложный вопрос?",
      answer:
        "Система автоматически определяет сложные случаи (жалобы, нестандартные запросы, негативные эмоции) и мгновенно передает их вам с полным контекстом переписки. Вы получаете push-уведомление и можете ответить лично.",
    },
    {
      question: "Безопасно ли подключать Instagram аккаунт?",
      answer:
        "Абсолютно. Мы используем официальное подключение Instagram от Meta, следуем всем политикам безопасности и имеем сертификацию партнера Meta. Ваши данные зашифрованы и никогда не передаются третьим лицам.",
    },
    {
      question: "Сколько времени занимает настройка?",
      answer:
        "Базовая настройка - 5 минут. Подключаете Instagram, загружаете информацию о продуктах (или импортируете из Shopify), и система начинает работать. Первые 24 часа система активно обучается и с каждым днем становится точнее.",
    },
    {
      question: "Можно ли использовать для нескольких брендов?",
      answer:
        "Да! Планы Growth и Scale поддерживают несколько Instagram аккаунтов. Каждый аккаунт имеет свои настройки стиля общения и товаров. Идеально для агентств или владельцев нескольких брендов.",
    },
  ]

  return (
    <section className="py-24 px-6 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-serif text-4xl md:text-5xl font-bold mb-4"
          >
            Частые вопросы
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-muted-foreground"
          >
            Все что нужно знать об InstaSell
          </motion.p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="border border-border rounded-xl overflow-hidden bg-secondary"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-background/50 transition-colors"
              >
                <span className="font-semibold text-lg pr-8">{faq.question}</span>
                <IconChevronDown
                  className={`w-5 h-5 flex-shrink-0 transition-transform ${openIndex === index ? "rotate-180" : ""}`}
                />
              </button>
              {openIndex === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                  className="px-6 pb-5 text-muted-foreground leading-relaxed"
                >
                  {faq.answer}
                </motion.div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
